






























































import {Component, Vue} from 'vue-property-decorator'
import {Getter, Mutation} from 'vuex-class'
import {Task, Location, Lead} from '@/store/types'
import TaskDateTime from './TaskDateTime.vue'
/* tslint:disable:no-var-requires */
const store = require('store')
/* tslint:disable:no-var-requires */
const {conformToMask} = require('vue-text-mask')
import LeadService from '@/classes/LeadService'
import DateFormatter from '@/classes/DateFormatter'

@Component({
  components: {
    TaskDateTime,
  },
})
export default class TaskInfo extends Vue {
  @Getter('task') public task!: Task
  @Getter('location') public location!: Location
  @Getter('lead') public lead!: Lead
  @Mutation('setTaskDateTimeModal') public setTaskDateTimeModal!: any

  public user = store.get('user')

  public get maskedPhone() {
    return conformToMask(this.lead.phone, LeadService.phoneMask).conformedValue
  }

  public get dateFormatted() {
    const dateFormatter = new DateFormatter()
    return dateFormatter.calendar(this.task.date + ' ' + this.task.time)
  }

  public showDirection() {
    const address = [
      this.location.address || '',
      this.location.city ? this.location.city.name : '',
      this.location.state ? this.location.state.name : '',
      this.location.state ? this.location.state.short : '',
      this.location.zip || '',
    ].join()
    return 'https://maps.google.com/?q=' + address
  }
}
